import { Injectable } from '@angular/core';
import {
  LoginFormValidate,
  ResetPasswordContent
} from '@com-delta-idp/mnx-login-ui';
import { ANALYTICS_EVENTS_LOGIN } from '../../constants/analytics-constants';
import * as LoginConstants from '../../constants/login-constant';
import { error } from '../../models/reset-password-api.interface';
import { ResetPasswordFacadeBaseService } from './reset-password-facade-base.service';
@Injectable({
  providedIn: 'root'
})
export class ResetPasswordFacadeHelper extends ResetPasswordFacadeBaseService {
  getResetPasswordContent(): ResetPasswordContent {
    return this.resetPasswordContent$.value || ({} as ResetPasswordContent);
  }

  resetPasswordFormFocusChange(fieldName: string) {
    LoginFormValidate.resetPasswordFormTouchControl(
      fieldName,
      this.getResetPasswordContent(),
      true
    );
  }

  resetPasswordFormValueChange(fieldName: string): void {
    LoginFormValidate.resetPasswordFormControlsOnSubmit(
      this.getResetPasswordContent(),
      fieldName,
      this.formSubmit
    );
    if (this.getResetPasswordContent().formGroup) {
      this.setAlertBanner();
    }
  }

  showHideOverylayMessage(value: boolean): void {
    this.getResetPasswordContent().hasError = value;
  }

  resetForm(): void {
    const storedUserId = this.loginModalService.lastEnteredUserId;
    this.getResetPasswordContent().formAttributes =
      this.resetPasswordhelperService.getFormAttributes();
    this.getResetPasswordContent().hasError = false;
    this.showHideOverylayMessage(false);
    this.getResetPasswordContent().formGroup?.reset();
    if (storedUserId) {
      this.getResetPasswordContent().formGroup?.patchValue({
        userId: { value: storedUserId, id: 'userId' }
      });
    }
    this.formSubmit = false;
    if (this.loginOAuthParams?.oauthConfig?.MFA_FLOW)
      this.getResetPasswordContent().formAttributes.isMfa = true;
    this.loginModalService.lastEnteredUserId = '';
  }

  handleError(errors: error[] = []) {
    const errorId = errors[0]?.code;
    if (errorId && this.checkForAccountRecoveryErrorCode(errorId)) {
      if (this.wifiPortalService.getQueryParamsWFP().isWFP) {
        this.wifiPortalService.isSecurityQuestionLocked(true);
        this.wifiPortalService.getRefreshUrlWFP(true);
        return;
      }
      this.recoverYourAccountFacadeService.getRecoverYourAccountPageContent();
      this.analytics.dispatchCustomEvent(
        ANALYTICS_EVENTS_LOGIN.RECOVERY_ACCOUNT_LOADED,
        true
      );
      this.nextDisplayViewService.nextDisplayView(
        LoginConstants.VIEW_NAME.RECOVER_ACCOUNT_SCREEN
      );
      this.resetForm();
    } else {
      this.setOverlayMessage(errorId);
    }
  }

  setOverlayMessage(errorId = '') {
    const errorCode = errorId ? `ERROR_MSG_${errorId}` : errorId;
    this.getResetPasswordContent().errorMessage =
      this.loginHelperUtils.getErrorMessageFromAem(this.aemContent, errorCode);
    this.showHideOverylayMessage(true);
  }

  checkForAccountRecoveryErrorCode(errorId: string) {
    return LoginConstants.RECOVER_ACCOUNT_SCREEN_ERROR_CODES.includes(errorId);
  }

  setActionButtonDisable(value: boolean): void {
    this.getResetPasswordContent().formAttributes.disableActionButton = value;
  }

  validateForm(): boolean {
    this.formSubmit = true;
    LoginFormValidate.resetPasswordFormControlsOnSubmit(
      this.getResetPasswordContent(),
      '',
      true
    );
    this.getResetPasswordContent().formAttributes.submitAttempt = true;
    return this.setAlertBanner();
  }

  setAlertBanner() {
    const errorCount = LoginFormValidate.validateFormFields(
      this.getResetPasswordContent().formGroup
    );
    this.getResetPasswordContent().formAttributes.errorCount = errorCount;
    this.getResetPasswordContent().formAttributes.errorAlertBanner =
      errorCount > 0;
    return errorCount > 0;
  }

  checkForSQAScreenDisplayHelper() {
    this.recoverSQAFacadeService.getSQADetails();
    this.recoverSQAFacadeService.sqaError$.subscribe((response) => {
      if (response) {
        this.getResetPasswordContent().errorMessage = response;
        this.showHideOverylayMessage(true);
      }
    });
  }
}
